import React from "react";

export const AuthLayout = React.lazy(() => import("./auth"));
export const MainLayout = React.lazy(() => import("./main"));
